import { useState, useEffect } from "react";
import { useTranslation } from "react-i18next";

import Typography from "@mui/material/Typography";
import TableCell from "@mui/material/TableCell";
import TableRow from "@mui/material/TableRow";
import InfoIcon from "@mui/icons-material/Info";
import AddCircleIcon from "@mui/icons-material/AddCircle";

import Button from "../../components/Button";
import TableComponent from "../../components/TableComponent";
import { deleteWrittenTest, getUsersInscribed, getUsersAttempts } from "../../api/training.deprecated";
import Confirm from "../../components/Confirm";
import request from "../../api/request";
import TrainingModuleStatus from "../../components/TrainingModuleStatus";
import useCrew from "../../hooks/useCrew";

export async function getSSID() {
  const ssid = await request(`/sts`);
  return ssid;
}

const WrittenTestTraining = ({ match, history }) => {
  const { t } = useTranslation();
  const [usersWrittenTest, setUsersWrittenTest] = useState([]);
  const [selectedTrainingId, setTrainingId] = useState(null);
  const [selectedOperationId, setSelectedOperationId] = useState(null);
  const [isDeleteModalShow, setIsDeleteModalShow] = useState(false);
  const [refresh, setRefresh] = useState(1);
  const { crew } = useCrew();

  async function confirmDeleteModal(isConfirmed) {
    if (isConfirmed) {
      await deleteWrittenTest(selectedOperationId);
    }
    setIsDeleteModalShow(false);
    setRefresh(refresh * -1);
  }

  useEffect(() => {
    (async () => {
      const trainingId = match.params.trainingId;
      setTrainingId(trainingId);
      const usersInscribed = await getUsersInscribed(trainingId, crew.id, crew.baseIds);
      const usersAttempts = await getUsersAttempts(trainingId, usersInscribed);

      setUsersWrittenTest(usersAttempts);
    })();
  }, [refresh, crew]);

  return (
    <>
      <Typography variant="h4">{t("training_pages.written_test")}</Typography>
      {usersWrittenTest && (
        <TableComponent
          header={[
            { title: t("training_pages.user_id"), style: { width: "5%" } },
            { title: t("user") },
            { title: t("training_pages.attempts") },
            { title: t("training.passed") },
            { title: t("actions") },
          ]}
          //writtenTestId
          renderChildren={(userWrittenTest, index) => (
            <TableRow key={index}>
              <TableCell>{userWrittenTest.userId}</TableCell>
              <TableCell>{userWrittenTest.fullname}</TableCell>
              <TableCell>{userWrittenTest.attempts}</TableCell>
              <TableCell>
                <TrainingModuleStatus status={userWrittenTest.passed} />
              </TableCell>

              <TableCell>
                <Button
                  icon={<InfoIcon />}
                  onClick={() =>
                    history.push(
                      `/training-users/user/written-test-info/${selectedTrainingId}/${userWrittenTest.userId}`,
                    )
                  }
                  title={t("training_pages.written_test_info")}
                />
                {userWrittenTest.attempts < process.env.REACT_APP_ATTEMPS && userWrittenTest.passed === 0 && (
                  <>
                    <Button
                      icon={<AddCircleIcon />}
                      onClick={() =>
                        history.push(
                          `/training-users/user/written-test/${selectedTrainingId}/${userWrittenTest.userId}`,
                        )
                      }
                      title={t("training_pages.add_written_test")}
                    />
                  </>
                )}
              </TableCell>
            </TableRow>
          )}
          search={["user_id", "fullname", "company_name"]}
          pagination
          items={usersWrittenTest}
        />
      )}
      <Button title={t("back")} onClick={() => history.goBack()}>
        {t("back")}
      </Button>
      {isDeleteModalShow && selectedOperationId && (
        <Confirm title={t("training_pages.delete_written_test")} onConfirm={confirmDeleteModal}>
          <p>{t("training_pages.delete_written_test_confirm")}</p>
        </Confirm>
      )}
    </>
  );
};

export default WrittenTestTraining;
